import axios from 'axios'
import Vue from 'vue'
import {Message} from 'element-ui'
import store from "../store";
import router from "../router";

let localdata = Vue.prototype.$getlocalStorage('userinfo')

var baseURL = process.env.VUE_APP_APIURL
axios.defaults.headers.get['Pragma'] = 'no-cache'
axios.defaults.headers.get['Cache-Control'] = 'no-cache, no-store'
const service = axios.create({
    baseURL,
    timeout: 120000,
    headers: {
        'content-type': "application/json;charset=UTF-8",
        'token': localdata.sessionId
    },
    onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
    }
})
service.interceptors.request.use(
    config => {
        let localdata = Vue.prototype.$getlocalStorage('userinfo')
        if (localdata) {
            config.headers.token = localdata.sessionId;
        }
        return config
    },
    (error) => {
        return Promise.reject(error)
    }
)

service.interceptors.response.use(
    (response) => {
        if (response instanceof Blob) {
            return response
        }
        if (response.data.code == -2) {
            store.commit('setuserinfo', '')
            localStorage.removeItem('userinfo')
            if (router.currentRoute.fullPath !== '/page/login') {
                router.replace({
                    path: '/page/login',
                    query: { redirect: router.currentRoute.fullPath }
                })
            }
            Message.error(response.data.msg);
            return false
        }
        if (response.data.code && response.data.code !== "0" && response.data.code !== -2) {
            Message.error(response.data.msg);
        }
        return response.data
    },
    (error) => {
        return error.response
    }
)

export default service
